export const CacheEntities = {
	terminal: 1,
	owner_company_data: 2,
};
